<template>
  <va-card title="Новини">
    <va-button
      :to="{ name: 'ms-capital-companies-edit' }"
    >
      Створити
    </va-button>
    <va-data-table
      :fields="fields"
      :data="companies"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: 'ms-capital-companies-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
        <va-button
          small
          @click="remove(props.rowData.id)"
          color="danger"
          class="ma-0">
          Видалити
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      companies: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [
        {
          name: 'label',
          title: 'Label',
          width: '40%',
        },
        {
          title: 'Опубліковано',
          name: '__slot:toggle',
          width: '20%',
        },
        {
          title: 'Переклади',
          name: '__slot:translations',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_MS_API_URL}/${this.locale}/admin/companies/${id}`, {
        published: !!this.news.find((item) => item.id === id).published,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    remove (id) {
      if (confirm('Дійсно видалити?')) {
        axios.delete(`${process.env.VUE_APP_MS_API_URL}/${this.locale}/admin/companies/${id}`)
          .then(response => {
            const idx = this.companies.findIndex(u => u.id === id)
            this.companies.splice(idx, 1)
            this.showToast('Success')
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_MS_API_URL}/${this.locale}/admin/companies`)
        .then(response => {
          console.log(response.data)
          this.companies = response.data
          this.companies.forEach((item) => {
            item.published = !!item.published
          })
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
